export const WEB3FORMS_ACCESS_KEY = import.meta.env.VITE_WEB3FORMS_ACCESS_KEY ?? '';
export const WEB3FORMS_ESTIMATE_ACCESS_KEY = import.meta.env.VITE_WEB3FORMS_ESTIMATE_ACCESS_KEY ?? '';
const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';

export async function submitToWeb3Forms(
  subject: string,
  fields: Record<string, string>,
  accessKey: string = WEB3FORMS_ACCESS_KEY
): Promise<boolean> {
  try {
    const response = await fetch(WEB3FORMS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        access_key: accessKey,
        subject,
        from_name: 'AXIS Cleaning Services Website',
        ...fields,
      }),
    });
    const result = await response.json();
    return Boolean(result.success);
  } catch {
    return false;
  }
}
